<template>
  <div class="panel" v-click-outside="panel_close" @click="panel_toggle">
    <div v-if="is_authenticated()" class="d-flex align-items-center">
      <availability v-if="!is_mobile()" class="panel__credits" />
      <div class="panel__deco">
        <div class="panel__avatar">
          <img class="panel__symbol" :src="avatar + '&background=0A76BD'" :alt="name"  />
        </div>
      </div>
    </div>
    <div v-else class="panel__deco">
      <div class="panel__burger">
        <vb-icon :name="'hamburger'" :color="sass('primary')" :size="23" />
      </div>
    </div>

    <panel-navigation v-show="links_open" :name="name" />
  </div>
</template>

<script>
import { get_config } from "@src/utilities"
import Availability from './availability.vue'
import PanelNavigation from './panel-navigation.vue'

export default {
  name: 'panel',

  components: {
    'availability': Availability,
    'panel-navigation': PanelNavigation,
  },

  props: {
    variant: {
      type: String,
      default: 'light',
    },
  },

  data() {
    return {
      avatar: '',
      name: '',
      links_open: false,
    }
  },

  computed: {
  },

  created() {
    window.addEventListener('scroll', () => {
      this.links_open = false
    })
  },

  mounted() {
    this.avatar = get_config('integration.avatarSrc', '')
    this.name = get_config('integration.displayName', '')
  },

  methods: {

    panel_close() {
      this.links_open = false
      document.body.classList.remove('menuOpen')
    },

    panel_toggle() {
      this.links_open = !this.links_open
      this.links_open ? document.body.classList.add('menuOpen') : document.body.classList.remove('menuOpen')
    },
  },
}
</script>

<style lang="scss" scoped>

  .panel {
    position: relative;

    &__deco {
      border: 1px solid $gray-300;
      padding: $grid-gutter-width / 3;
      border-radius: 50px;
      display: flex;
      align-items: center;
      background-color: $white;
      cursor: pointer;
    }

    &__credits {
      @extend .panel__deco;
      margin-right: $grid-gutter-width / 3;
      padding: 13px 15px; // Adjusted padding for better alignment
      border-color: $white;
      cursor: default;

      ::v-deep {
        .availability__credits {
          display: flex;
          align-items: center;

          & > div {
            margin-right: $grid-gutter-width / 2;
            padding-right: $grid-gutter-width / 2;
            border-right: 1px solid $gray-300;

            &:last-child {
              margin-right: 0;
              border: none;
              padding-right: 0;
            }
          }
        }
      }
    }

    &__avatar {
      width: 30px;
      height: 30px;
      overflow: hidden;
      border-radius: 50%;

      img {
        max-width: 100%;
      }
    }
  }

</style>